import * as Contentful from 'contentful'

export enum AnimationKey {
  LlamaShowcase = 'Llama Showcase',
  ProfessionalOutcomes = 'Professional Outcomes',
  CheckTypes = 'Check Types',
  StudentLP = 'Student Landing Page',
  AbstractCommunicate = 'Abstract Communicate',
  AbstractWaves = 'Abstract Waves',
  Fluency = 'Fluency',
  OffensiveContentReporting = 'Offensive Content Reporting',
  Director = 'Director',
}

export interface TypeAssetLottieAnimationFields {
  internalName: Contentful.EntryFields.Symbol
  placeholderImage?: Contentful.Asset
  altTitle?: Contentful.EntryFields.Text
  altAttribute?: Contentful.EntryFields.Text
  loopAnimation: Contentful.EntryFields.Boolean
  animationKey: AnimationKey
  dropShadow?: Contentful.EntryFields.Boolean
}

export type TypeAssetLottieAnimation = Contentful.Entry<TypeAssetLottieAnimationFields>
